// src/shared/services/api.ts
import axios from 'axios';

// Création d'une instance Axios
export const api = axios.create({
  // TODO: baseURL à remplacer par l'url du back selon l'environnement
    //baseURL: "http://localhost:8091/pecheapi",
    baseURL: "https://www.eaurel.fr/pecheapi",
  headers: {
    'Content-Type': 'application/json',
  },
});

// Création d'une instance Axios avec token
export const apiSecure = axios.create({
  // TODO: baseURL à remplacer par l'url du back selon l'environnement
    //baseURL: "http://localhost:8091/pecheapi",
    baseURL: "https://www.eaurel.fr/pecheapi",
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem("token") || ''}`
  },
});

// Intercepteur pour gérer les erreurs globalement (optionnel)
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);